import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, nightOwl, vsDark } from "@code-surfer/themes";
const styledCenter = {
  width: "fit-content",
  textAlign: "center",
  borderBottom: '10px solid',
  borderImageSource: "linear-gradient(120deg, #1890ff, #db18ff)",
  borderImageSlice: 5
};
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <CodeSurfer themes={[nightOwl]} mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "title=\"useImperativeHandle\" subtitle=\"customizes the instance value\"",
          "title": "\"useImperativeHandle\"",
          "subtitle": "\"customizes",
          "the": true,
          "instance": true,
          "value\"": true
        }}>{`const MyInput = React.forwardRef((props, ref) => {
  const [val, setVal] = React.useState('');
  const inputRef = React.useRef();

  React.useImperativeHandle(ref, () => ({
    blur: () => {
      document.title = val;
      inputRef.current.blur();
    }
  }));

  return (
    <input
      ref={inputRef}
      val={val}
      onChange={e => setVal(e.target.value)}
      {...props}
    />
  );
});

const App = () => {
  const ref = React.useRef(null);
  const onBlur = () => {
    console.log(ref.current);
    ref.current.blur();
  };

  return <MyInput ref={ref} onBlur={onBlur} />;
};

`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "5:10 title=\"useImperativeHandle\" subtitle=\"replace native functions\"",
          "5:10": true,
          "title": "\"useImperativeHandle\"",
          "subtitle": "\"replace",
          "native": true,
          "functions\"": true
        }}>{`const MyInput = React.forwardRef((props, ref) => {
  const [val, setVal] = React.useState('');
  const inputRef = React.useRef();

  React.useImperativeHandle(ref, () => ({
    blur: () => {
      document.title = val;
      inputRef.current.blur();
    }
  }));

  return (
    <input
      ref={inputRef}
      val={val}
      onChange={e => setVal(e.target.value)}
      {...props}
    />
  );
});

const App = () => {
  const ref = React.useRef(null);
  const onBlur = () => {
    console.log(ref.current);
    ref.current.blur();
  };

  return <MyInput ref={ref} onBlur={onBlur} />;
};

`}</code></pre>
    </CodeSurfer>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      